import { Col, Form, Input, Modal, Row, Select, Space, Table } from 'antd'
import { FormFields, useSetupHook } from './hooks'
import { XhTableColumnTypeV5 } from '@xhgj/xh-components'
import { BrandInfoVO } from '@/api/dock'
import AsyncButton from '../AsyncButton'
import { formatBrandDisplay } from './formatBrandDisplay'

export interface Props {
  title?: string
  applyForType?: string
  onSubmit?: () => Promise<void>
  value?: string | string[]
  onChange?: (value: string, options?: any) => void
  postOnChange?: (options?: any) => void
  platformCode: string
  disabled?: boolean
  placeholder?: string
  categoryCode?: string // 类目编码
  displayCode?: string // 传了就在输入框显示「中文（英文）/编码」，表单值不变
}
export function BrandSelect(props: Props) {
  const {
    state,
    cancelTicketRelationModal,
    handlePaginationChange,
    handleTableChangeCheck,
    hanleSearch,
    form,
    handleReset,
    showBrandSelectModal,
    value,
    onRowClick,
  } = useSetupHook(props)

  const {
    dataSource,
    isTicketRelationModalOpen,
    paginationOption,
    selectedRowKeys,
  } = state
  const { title = '客户品牌', disabled, placeholder, displayCode } = props
  const displayValue =
    displayCode && typeof value === 'string' && value
      ? formatBrandDisplay(value, displayCode)
      : value

  const columns: XhTableColumnTypeV5<BrandInfoVO> = [
    {
      key: 'brandCode',
      title: '品牌编码',
      dataIndex: 'brandCode',
    },
    {
      key: 'brandName',
      title: '品牌名称',
      dataIndex: 'brandName',
    },
  ]

  return (
    <div>
      <Input
        onClick={showBrandSelectModal}
        value={displayValue}
        placeholder={placeholder}
        disabled={disabled}
      ></Input>
      <Modal
        title={title}
        open={isTicketRelationModalOpen}
        width={800}
        // className="h-[600px]"
        wrapClassName="h-[1000px]"
        onCancel={cancelTicketRelationModal}
        centered
        destroyOnClose
        footer={null}
      >
        <div className="font-bold py-[10px]">
          <Row gutter={20}>
            <Col flex={1}>
              <Form form={form}>
                <Row gutter={20}>
                  <Col span={12}>
                    <Form.Item<FormFields> name="brandCode" label="品牌编码">
                      <Input placeholder="请输入" allowClear></Input>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item<FormFields> name="brandName" label="品牌名称">
                      <Input placeholder="请输入" allowClear></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Col>
            <Col flex={'100px'}>
              <Space>
                <AsyncButton onClick={handleReset}>重置</AsyncButton>
                <AsyncButton type="primary" onClick={hanleSearch}>
                  查询
                </AsyncButton>
              </Space>
            </Col>
          </Row>
        </div>
        <Table
          dataSource={dataSource}
          columns={columns as any}
          rowKey="id"
          //   isLoading={isTableLoading}
          //   width={1200}
          scroll={{ x: 400, y: 500 }}
          onRow={(record) => ({ onClick: () => onRowClick(record) })}
          pagination={{
            current: paginationOption.pageNo,
            // pageSize: paginationOption.pageSize,
            pageSize: paginationOption.pageSize,
            total: paginationOption.totalCount,
            onChange: handlePaginationChange,
            showSizeChanger: false,
            showQuickJumper: false,
            showTotal: () => <span>共{paginationOption.totalCount}条</span>,
            // pageSizeOptions: [30, 100, 500, 1000, 2000],
          }}
        ></Table>
      </Modal>
    </div>
  )
}
import { Col, Form, Input, Modal, Row, Select, Space, Table } from 'antd'
import { FormFields, useSetupHook } from './hooks'
import { XhTableColumnTypeV5 } from '@xhgj/xh-components'
import { BrandInfoVO } from '@/api/dock'
import AsyncButton from '../AsyncButton'
import { formatBrandDisplay } from './formatBrandDisplay'

export interface Props {
  title?: string
  applyForType?: string
  onSubmit?: () => Promise<void>
  value?: string | string[]
  onChange?: (value: string, options?: any) => void
  postOnChange?: (options?: any) => void
  platformCode: string
  disabled?: boolean
  placeholder?: string
  categoryCode?: string // 类目编码
  displayCode?: string // 传了就在输入框显示「中文（英文）/编码」，表单值不变
}
export function BrandSelect(props: Props) {
  const {
    state,
    cancelTicketRelationModal,
    handlePaginationChange,
    handleTableChangeCheck,
    hanleSearch,
    form,
    handleReset,
    showBrandSelectModal,
    value,
    onRowClick,
  } = useSetupHook(props)

  const {
    dataSource,
    isTicketRelationModalOpen,
    paginationOption,
    selectedRowKeys,
  } = state
  const { title = '客户品牌', disabled, placeholder, displayCode } = props
  const displayValue =
    displayCode && typeof value === 'string' && value
      ? formatBrandDisplay(value, displayCode)
      : value

  const columns: XhTableColumnTypeV5<BrandInfoVO> = [
    {
      key: 'brandCode',
      title: '品牌编码',
      dataIndex: 'brandCode',
    },
    {
      key: 'brandName',
      title: '品牌名称',
      dataIndex: 'brandName',
    },
  ]

  return (
    <div>
      <Input
        onClick={showBrandSelectModal}
        value={displayValue}
        placeholder={placeholder}
        disabled={disabled}
      ></Input>
      <Modal
        title={title}
        open={isTicketRelationModalOpen}
        width={800}
        // className="h-[600px]"
        wrapClassName="h-[1000px]"
        onCancel={cancelTicketRelationModal}
        centered
        destroyOnClose
        footer={null}
      >
        <div className="font-bold py-[10px]">
          <Row gutter={20}>
            <Col flex={1}>
              <Form form={form}>
                <Row gutter={20}>
                  <Col span={12}>
                    <Form.Item<FormFields> name="brandCode" label="品牌编码">
                      <Input placeholder="请输入" allowClear></Input>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item<FormFields> name="brandName" label="品牌名称">
                      <Input placeholder="请输入" allowClear></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Col>
            <Col flex={'100px'}>
              <Space>
                <AsyncButton onClick={handleReset}>重置</AsyncButton>
                <AsyncButton type="primary" onClick={hanleSearch}>
                  查询
                </AsyncButton>
              </Space>
            </Col>
          </Row>
        </div>
        <Table
          dataSource={dataSource}
          columns={columns as any}
          rowKey="id"
          //   isLoading={isTableLoading}
          //   width={1200}
          scroll={{ x: 400, y: 500 }}
          onRow={(record) => ({ onClick: () => onRowClick(record) })}
          pagination={{
            current: paginationOption.pageNo,
            // pageSize: paginationOption.pageSize,
            pageSize: paginationOption.pageSize,
            total: paginationOption.totalCount,
            onChange: handlePaginationChange,
            showSizeChanger: false,
            showQuickJumper: false,
            showTotal: () => <span>共{paginationOption.totalCount}条</span>,
            // pageSizeOptions: [30, 100, 500, 1000, 2000],
          }}
        ></Table>
      </Modal>
    </div>
  )
}
